import { Button } from "components/Button/Button";
import { Loading } from "components/Loading/loading";
import { useEffect, useRef, useState } from "react";

import { Message } from "components/Message/Message";
import { InputDetector } from "../../InputDetector";
import {
  GroupingPriceFunction,
  RoundWithExcelMethod,
  uuidv4,
} from "utils/helpers";
import { Toast } from "components/ToastShow/ToastAlert";
import { InputTypes, MessageType } from "types/enum";

interface DataGridDataEntryProps {
  gridKey: string;
  id?: string;
  jobId?: string;
  PRJ_UID?: string;
  mode: "create" | "view" | "edit";
  EnableDisplacement?: boolean;
  firstAutoValue?: boolean;
  GridFields?: any;
  onHide?: (e: boolean) => void;
  saveRowhandler?: (e: any) => void;
  EntryMode?: string;
  editedRow?: any;
  condition?: any;
  formula?: any;
}

export const DataGridDataEntry = ({
  gridKey,
  editedRow,
  condition,
  formula,
  EntryMode,
  saveRowhandler,
  firstAutoValue = true,
  GridFields,
  EnableDisplacement = false,
  onHide,
  mode,
}: DataGridDataEntryProps) => {
  const [inputs, setInputs] = useState<any>([]);
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [resetForm, setResetForm] = useState<boolean>(true);
  const [times, setTimes] = useState<any>({});
  const selectedFromDynamicDictionary = useRef<any>();
  const [openStepStatus, setOpenStepStatus] = useState<any>({});
      const newObj=useRef<any>()

 inputs?.map(item=>{
        
  
  
    item?.defaultValue?
                        item.typeName=="number" || item.typeName=="decimalNumber" || item.typeName=="price"?newObj.current={...newObj.current,[item.SystemKey]:+item?.defaultValue}:newObj.current={...newObj.current,[item.SystemKey]:item?.defaultValue}
            :
            item.typeName=="number" || item.typeName=="decimalNumber" || item.typeName=="price"?newObj.current={...newObj.current,[item.SystemKey]:0}:newObj.current={...newObj.current,[item.SystemKey]:""}
  
  
  
  //    item.typeName=="number" || item.typeName=="decimalNumber" || item.typeName=="price"?newObj.current={...newObj.current,[item.SystemKey]:0}:newObj.current={...newObj.current,[item.SystemKey]:""}
           
          })







  
  const [catchMessage, setCatchMessage] = useState<any>({
    type: "info",
    msg: "NoDataForPreview",
  });
  const DynamicFormRef = useRef<any>();
  const FormulaObjectRef = useRef<any>({});

  const handleInput = (event) => {

  try{
              newObj.current={...newObj.current,[event.target.name]:event.target?.type=='number'?+event.target?.value:event?.target?.type=='checkbox'?
                            event?.target?.checked==true?1:0:event.target?.value
                        }
    for (let key in FormulaObjectRef.current) {
      
      if (
        FormulaObjectRef.current[key] != "string" &&
        FormulaObjectRef.current[key] !=
        "newObj.current?.string" &&
        DynamicFormRef.current[key]
      ) {
        const isPrice = inputs?.find((item) => item?.SystemKey == key);

        const activeElement =
          event.target.tagName === "INPUT"
            ? event.target
            : (document.activeElement as any);
        let preValue = DynamicFormRef.current[key].value || "";
        if (
          activeElement?.name == key ||
          (!FormulaObjectRef.current[key].includes(activeElement?.name) &&
            activeElement.name) ||
          (!FormulaObjectRef.current[key].includes(
            selectedFromDynamicDictionary?.current
          ) &&
            selectedFromDynamicDictionary?.current &&
            (!activeElement.name ||
              activeElement.name == selectedFromDynamicDictionary.current))
        ) {
          if (isPrice?.initialSystemKey == "price") {
          } else {
            const result=DynamicFormRef.current[key].value || ""
            DynamicFormRef.current[key].value =result?.toString()?.includes("undefined") || !result?'':result

            newObj.current={...newObj.current,[key]:DynamicFormRef.current[key].type=="number"?
              result?.toString()?.includes("undefined") || !result?0:+result
              
              :result?.toString()?.includes("undefined") || !result?'':result}

          }
        } else {
          if (isPrice?.initialSystemKey == "price") {


const result=GroupingPriceFunction(
              isPrice?.currencyRoundingPlace ||
                isPrice?.currencyRoundingPlace == 0
                ? RoundWithExcelMethod(
                    data?.[key] && mode == "view"
                      ? data?.[key]
                      : eval(FormulaObjectRef.current[key]) != Infinity
                      ? eval(FormulaObjectRef.current[key])
                      : preValue,
                    isPrice?.currencyRoundingPlace
                  )
                : data?.[key] && mode == "view"
                ? data?.[key]
                : eval(FormulaObjectRef.current[key]) != Infinity
                ? eval(FormulaObjectRef.current[key])
                : preValue
            );

            DynamicFormRef.current[key].value = result?.toString()?.includes("undefined") || !result?'0':result






 newObj.current={...newObj.current,[key]:

         result?.toString()?.includes("undefined") || !result?'0':result
                        }


          } else {
 const result=   data?.[key] && mode == "view"
                ? data?.[key]
                : eval(FormulaObjectRef.current[key]) != Infinity
                ? eval(FormulaObjectRef.current[key])
                : preValue;
            
            DynamicFormRef.current[key].value =
            result?.toString()?.includes("undefined") || !result?'':result


 newObj.current={...newObj.current,[key]:
                                    DynamicFormRef.current[key].type=="number"?
                              result?.toString()?.includes("undefined") || !result?0:+result
                                    
                                    :
                                    result?.toString()?.includes("undefined") || !result?'':result
                                   
                                  }






          }
          setTimeout(() => {
            if (
              (eval(FormulaObjectRef.current[key]) ||
                eval(FormulaObjectRef.current[key]) == 0) &&
              (preValue == ""
                ? true
                : preValue != eval(FormulaObjectRef.current[key])) &&
              eval(FormulaObjectRef.current[key]) != Infinity
            ) {
              DynamicFormRef.current[key].dispatchEvent(
                new Event("input", { bubbles: true })
              );
            }
          }, 0);
        }

      }
      // DynamicDataGridFormRef.current[key].value = eval(FormulaObjectRef.current[key])
    }


    
    selectedFromDynamicDictionary.current = null;
  }catch{}
  };
  const handleSubmit = async (event, close = false) => {
    const obj: any = {};
    inputs.map((input) => {
      if (input?.SystemKey != undefined && input.typeName != "step") {
        if (
          input.typeName == "textArea" ||
          input.typeName == "number" ||
          input.typeName == "decimalNumber" ||
          input.typeName == "text" ||
          input.typeName == "price" ||
          input.typeName == "items" ||

          input.typeName == "RadioButton" ||
          input.typeName == "radio" ||
          input.typeName == "PositionDictionary"
        ) {
          obj[input.SystemKey] =
          input.typeName == 'price'?event[input.SystemKey].value?event[input.SystemKey].value?.replaceAll(',',''):null:
            input.typeName == "text" && input?.InputType == 6
              ? event[input.SystemKey].value
              : event[input.SystemKey].value
              ? event[input.SystemKey].value
              : null;
          //  obj.typeNames={...obj.typeNames,[input.SystemKey]:input.typeName}
        } else if (input.typeName == "timeLength") {
          obj[input.SystemKey] = event[input.SystemKey][0].value
            ? event[input.SystemKey][0].value
            : null;
          //  obj.typeNames={...obj.typeNames,[input.SystemKey]:input.typeName}
        } else if (input.typeName == "checkBox") {
          obj[input.SystemKey] = event[input.SystemKey].checked + "";
          // obj.typeNames={...obj.typeNames,[input.SystemKey]:input.typeName}
        } else if (input.typeName == "date" || input.typeName == "time") {
          obj[input.SystemKey] = times[input.SystemKey]
            ? times[input.SystemKey]
            : null;
          // obj.typeNames={...obj.typeNames,[input.SystemKey]:input.typeName}
        } else if (
          input.backendType == "guid" ||
          input.type == InputTypes.DynamicDictionary
        ) {
          obj[input.SystemKey] = event[input.SystemKey + "value"]?.value
            ? event[input.SystemKey + "value"].value
            : event[input.SystemKey]?.value
            ? event[input.SystemKey]?.value
            : null;
          obj[input.SystemKey + "Description"] =
            event[input.SystemKey + "Description"].value;
          //  obj.typeNames={...obj.typeNames,[input.SystemKey]:input.typeName}
        } else if (input.typeName == "selectBox") {
          // console.log("sssss"  , event[input.SystemKey].options[event[input.SystemKey].selectedIndex] , event[input.SystemKey].options[event[input.SystemKey].selectedIndex].text)
          obj[input.SystemKey] = event[input.SystemKey].options[
            event[input.SystemKey].selectedIndex
          ].text
            ? event[input.SystemKey].options[
                event[input.SystemKey].selectedIndex
              ].text
            : null;
          //obj[input.SystemKey+"Description"] = event[input.SystemKey].options[event[input.SystemKey].selectedIndex].text
        }
      }
    });

    try {
      saveRowhandler &&
        saveRowhandler(
          EntryMode == "edit"
            ? { ...obj, Id: editedRow.Id }
            : { ...obj, Id: uuidv4() }
        );
      if (close) {
        onHide && onHide(false);
      } else {
        Toast("msg_saveddatasuccessfully", MessageType.success);
        setResetForm(false);
        setTimes({});
      }
    } catch (error) {
      // Handle error
    }
  };

  const CalculateRoundingPlace = (e, systemKey) => {
   
    // if (
    //   FormulaObjectRef.current?.[systemKey] != "string" &&
    //   FormulaObjectRef.current?.[systemKey] !=
    //     "newObj.current?.string" &&
    //   DynamicFormRef.current?.[systemKey]
    // ) {
    //   const isPrice = inputs?.find((item) => item?.SystemKey == systemKey);
    //   DynamicFormRef.current[systemKey].value = GroupingPriceFunction(
    //     isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace == 0
    //       ? RoundWithExcelMethod(
    //           e?.replaceAll(",", "") || 0,
    //           isPrice?.currencyRoundingPlace
    //         )
    //       : e?.replaceAll(",", "") || 0
    //   );
    //   let preValue = GroupingPriceFunction(
    //     isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace == 0
    //       ? RoundWithExcelMethod(
    //           e?.replaceAll(",", "") || 0,
    //           isPrice?.currencyRoundingPlace
    //         )
    //       : e?.replaceAll(",", "") || 0
    //   );
    //   setTimeout(() => {
    //     //  if((eval(FormulaObjectRef.current?.[systemKey])||eval(FormulaObjectRef.current?.[systemKey])==0) &&(preValue==0? true :  preValue !=eval(FormulaObjectRef.current?.[systemKey])) && eval(FormulaObjectRef.current?.[systemKey]) != Infinity ){
    //     DynamicFormRef.current?.[systemKey].dispatchEvent(
    //       new Event("input", { bubbles: true })
    //     );

    //     // }
    //   }, 0);
    // }





        if(FormulaObjectRef.current?.[systemKey]!="string" && FormulaObjectRef.current?.[systemKey]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current?.[systemKey]){
          const isPrice= inputs.flatMap(item=>item.inputList).find(item=>item?.SystemKey==systemKey)          
          DynamicFormRef.current[systemKey].value =GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0? RoundWithExcelMethod(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace):e?.replaceAll(',','') || 0)
          let preValue =GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0?RoundWithExcelMethod(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace):e?.replaceAll(',','') || 0) 
          setTimeout(() => {
              //  if((eval(FormulaObjectRef.current?.[systemKey])||eval(FormulaObjectRef.current?.[systemKey])==0) &&(preValue==0? true :  preValue !=eval(FormulaObjectRef.current?.[systemKey])) && eval(FormulaObjectRef.current?.[systemKey]) != Infinity ){
                    DynamicFormRef.current?.[systemKey].dispatchEvent(new Event('input', { bubbles: true }));

                   // }
             }, 0);
             newObj.current={...newObj.current,[systemKey]:GroupingPriceFunction(isPrice?.currencyRoundingPlace || isPrice?.currencyRoundingPlace==0? RoundWithExcelMethod(e?.replaceAll(',','') || 0,isPrice?.currencyRoundingPlace):e?.replaceAll(',','') || 0)
                        }
        }


  };




const setCodeCallback=(object,systemKey)=>{

    newObj.current={...newObj.current,[systemKey+'Object']:object}


    
    DynamicFormRef.current[systemKey].value =object?.Code

    // DynamicFormRef.current[systemKey].value =eval(FormulaObjectRef.current[systemKey])!= Infinity?eval(FormulaObjectRef.current[systemKey]): Object.values(object)[0]
    //    if(dependencyObjectRef.current?.[systemKey]!="string" && dependencyObjectRef.current?.[systemKey]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current?.[systemKey]){
       
        setTimeout(() => {
              //  if((eval(FormulaObjectRef.current?.[systemKey])||eval(FormulaObjectRef.current?.[systemKey])==0) &&(preValue==0? true :  preValue !=eval(FormulaObjectRef.current?.[systemKey])) && eval(FormulaObjectRef.current?.[systemKey]) != Infinity ){
                    DynamicFormRef.current?.[systemKey].dispatchEvent(new Event('input', { bubbles: true }));

                   // }
             }, 0);
    
//     for (let key in dependencyObjectRef.current) {


// if( dependencyObjectRef.current[key]?.split('.')?.[0]==systemKey){
// let x=dependencyObjectRef.current[key]?.replaceAll([systemKey],"object")


//            // if(FormulaObjectRef.current[key]!="string" && FormulaObjectRef.current[key]!="Number(DynamicFormRef.current?.string?.value)" && DynamicFormRef.current[key]){
//             let preValue = DynamicFormRef.current[key].value
                  
//              DynamicFormRef.current[key].value = (data?.[key] && mode=='view')?data?.[key]: (eval(x)!= Infinity?eval(x):preValue )
                                
//               setTimeout(() => {
//                 if((eval(x)||eval(x)==0) &&(preValue==""? true :  preValue !=eval(x)) && eval(x) != Infinity ){
//                     DynamicFormRef.current[key].dispatchEvent(new Event('input', { bubbles: true }));

//                     }
//              }, 0);
        
//         //}
//        // }
//       //  setData({...data ,...newObject })
//        selectedFromDynamicDictionary.current=null








      
//         }
// }


}


  async function getGridDataByKeyAsync(gridKey) {
    setLoading(false);
    try {
      // const response = await getGridDataByKey(gridKey);
      // setInputs(JSON.parse(response.Data?.DynamicForms.FormFields));
      // setCatchMessage({ type: "info", msg: "NoDataForPreview" });
    } catch (err: any) {
      setCatchMessage({ type: "error", msg: err?.response?.data?.Message });
    }
    setLoading(true);
  }

  useEffect(() => {
    if (GridFields) {
      let formolObj: any = formula;
      if (GridFields[0]?.inputList) {
        setInputs(GridFields.flatMap((item) => item.inputList));
        if (!formula) {
          GridFields.flatMap((item) => item.inputList).map((item) => {
            if (item.Formula && item.Formula.length > 1) {
              formolObj = {
                ...formolObj,
                [item.SystemKey]: item.Formula,
              };
            }
          });
        }
      } else {
        setInputs(GridFields);
        if (!formula) {
          GridFields.map((item) => {
            if (item.Formula && item.Formula.length > 1) {
              formolObj = {
                ...formolObj,
                [item.SystemKey]: item.Formula,
              };
            }
          });
        }
      }
      FormulaObjectRef.current = formolObj;
    } else {
      getGridDataByKeyAsync(gridKey);
    }
  }, [GridFields]);
  useEffect(() => {
    if (!resetForm) {
      setResetForm(true);
    }
  }, [resetForm]);

  useEffect(() => {
    if (
      inputs[0]?.backendType == "guid" ||
      inputs[0]?.type == InputTypes.DynamicDictionary
    ) {
      document
        .getElementsByName(inputs[0]?.SystemKey + "Description")[0]
        ?.focus();
    } else {
      document?.getElementsByName(inputs[0]?.SystemKey)[0]?.focus();
    }
  }, [inputs]);

  function CalculateCallBack(value, inputKey,haveTag=false) {
    
    let val=haveTag ?DynamicFormRef.current?.[inputKey]?.value?DynamicFormRef.current?.[inputKey]?.value:value:value
   // DynamicFormRef.current[inputKey].value=DynamicFormRef.current?.[inputKey]?.value
         if(val !=null && value!=undefined){

          
            if(/^\d+(\.\d+)?$/.test(val?.toString())){
             
                newObj.current={...newObj.current,[inputKey] :+val}
            }
            else{
               
                newObj.current={...newObj.current,[inputKey] :val}
            }
        }

        selectedFromDynamicDictionary.current=inputKey
    //selectedFromDynamicDictionary.current = inputKey;
  }

  return (
    <>
      {loading ? (
        <>
          {inputs && data ? (
            <>
              <form action="" ref={DynamicFormRef} onInput={handleInput}>
                <div className="card mx-2 mt-1 formBuilder__formBx">
                  {resetForm && (
                    <div className="row">
                      {inputs?.map((Obj, index) => {
                        return (
                          <>
                            <div
                              id={"inputsId" + index}
                              className={` align-items-start formBuilder__formBx__active col-${
                                Obj?.size
                              } formBoxDr in   ${"d-flex"}
                                            `}
                            >
                              <div
                                className={`d-flex ${
                                  Obj.typeName == "checkBox"
                                    ? "align-items-center"
                                    : "align-items-start"
                                } h-100 justify-content-between w-100 formBoxDr iwn`}
                                id={index}
                              >
                                <InputDetector
                                  CalculateRoundingPlace={
                                    CalculateRoundingPlace
                                  }
                                  CalculateCallBack={CalculateCallBack}
                                  useOnInput={true}
                                  mode={
                                    Obj.SystemKey == "SystemNumber"
                                      ? "view"
                                      : mode
                                  }
                                  dataEntry
                                  setCodeCallback={setCodeCallback}
                                  firstAutoValue={firstAutoValue}
                                  EnableDisplacement={EnableDisplacement}
                                  typeName={Obj.typeName}
                                  property={{
                                    ...Obj,
                                    defaultValue:
                                      // Obj.initialSystemKey == "price"
                                      //   ? Obj?.currencyRoundingPlace ||
                                      //     Obj?.currencyRoundingPlace == 0
                                      //     ? RoundWithExcelMethod(
                                      //         EntryMode == "edit"
                                      //           ? editedRow[
                                      //               Obj.SystemKey
                                      //             ]?.replaceAll(",", "")
                                      //           : (data?.[Obj.SystemKey]
                                      //               ? data?.[
                                      //                   Obj.SystemKey
                                      //                 ]?.replaceAll(",", "")
                                      //               : Obj?.defaultValue
                                      //             )?.replaceAll(",", ""),
                                      //         Obj?.currencyRoundingPlace
                                      //       )
                                      //     :
                                      //      EntryMode == "edit"
                                      //     ? editedRow[
                                      //         Obj.SystemKey
                                      //       ]?.replaceAll(",", "")
                                      //     : (data?.[Obj.SystemKey]
                                      //         ? data?.[
                                      //             Obj.SystemKey
                                      //           ]?.replaceAll(",", "")
                                      //         : Obj?.defaultValue
                                      //       )?.replaceAll(",", "")
                                      //   :
                                         EntryMode == "edit"
                                        ? editedRow[Obj.SystemKey]
                                        : data?.[Obj.SystemKey]
                                        ? data?.[Obj.SystemKey]
                                        : Obj?.defaultValue,
                                  }}
                                  handleTime={(e) => {
                                    setTimes({ ...times, [Obj.SystemKey]: e });
                                  }}
                                  changeProperty={function (e: any): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  )}
                  <div className="col-lg-12 btns_form">
                    {mode != "view" ? (
                      <div>
                        {EntryMode == "edit" && (
                          <Button
                            btnType="primaryFill"
                            value="Save"
                            onClick={() => {
                              handleSubmit(DynamicFormRef.current, true);
                            }}
                          />
                        )}
                        {EntryMode == "create" && (
                          <Button
                            btnType="primaryFill"
                            value="SaveAndClose"
                            onClick={() => {
                              handleSubmit(DynamicFormRef.current, true);
                            }}
                          />
                        )}
                        {/*                                             <Button btnType="cancel" value="cancel" onClick={() => { onHide && onHide(false) }} />
                         */}{" "}
                      </div>
                    ) : (
                      <div className="m-1">
                        <Button
                          btnType="primary"
                          value="close"
                          onClick={() => {
                            onHide && onHide(false);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </>
          ) : (
            <Message message={catchMessage.msg} type={catchMessage.type} />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};
